<template>
  <div class="no-result-teaser-data" >
    <div class="message" v-html="noResultData.noResultText"></div>
    <div class="action">
       <button @click="restart">{{
          translationHelper.getTranslation("wbk_Btn_RestartSearch")
        }}</button>
      <button  @click="support">{{noResultData.supportLinkText}}</button> </div>
     </div>
</template>

<script>
export default {
    props:["noResultData","translationHelper"],
    methods:{
      restart(){
        this.$emit('restart-wizard')
      },
      support(){
         window.open(this.noResultData.supportLinkUrl, this.noResultData.supportLinkTarget)
      }
    }
}
</script>
